export default __webpack_public_path__ + "4bb5e7502912024f85f7b62634a3f0ee.svg";